import { Component } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-upload-req-work-flow-step-warning-modal',
  templateUrl: './upload-req-work-flow-step-warning-modal.component.html'
})
export class UploadReqWorkFlowStepWarningModalComponent {

  modalData: any = {};

  constructor(private bsModalRef: BsModalRef, private bsModalService: BsModalService) {
    if (this.bsModalService.config.initialState) {
      this.modalData = this.bsModalService.config.initialState;
    }
  }

  closeModal() {
    this.bsModalRef.hide();
  }
}
